import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HolidayModalContainerComponent } from './holiday-modal/holiday-modal.container';
import { HolidayModalComponent } from './holiday-modal/holiday-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        HolidayModalContainerComponent,
        HolidayModalComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        SharedModule
    ]
})
export class HolidayModule { }
